import UnifiedPlayer from '@tv2-player/unifiedplayer/src/core/UnifiedPlayer';
// eslint-disable-next-line monorepo-dependencies/no-unlisted-package-import
import { LoadRequestData } from 'chromecast-caf-receiver/cast.framework.messages';
import { Media } from '@tv2-player/unifiedplayer';
import { onEither } from '@tv2/lib-graphql/typeHelper';
import { ChromecastUser } from '@tv2-player/unifiedplayer/src/types/ChromecastUser';
import { PluginInterface } from './PluginInterface';
import { errorAction, loadRequestFilter, playerFilter } from '../extensions';
import { normalizeErrors } from '../../handlers/error';
import { mapBusinessErrorTypeToMessage } from '../../handlers/errorMessages';
import type { ChromecastPlayRequestCustomData } from '../../types';
import { getChromecastUser } from '../../utils/getChromecastUser';

export class BusinessErrorPlugin implements PluginInterface {
  private player: UnifiedPlayer;
  private user: ChromecastUser;

  init() {
    playerFilter.register(this.playerTransform.bind(this));
    loadRequestFilter.register(this.loadTransform.bind(this), 9);
    errorAction.register(this.businessErrorTransform.bind(this));
  }

  async playerTransform(player: UnifiedPlayer) {
    this.player = player;
    return player;
  }

  async loadTransform(loadRequestData: LoadRequestData) {
    const customData = loadRequestData.customData as ChromecastPlayRequestCustomData;
    this.user = getChromecastUser(customData);
    return loadRequestData;
  }

  async businessErrorTransform(error: any) {
    if ('data' in error && 'errors' in error) {
      const normalizedError = normalizeErrors(error)[0];
      const errorType = mapBusinessErrorTypeToMessage(normalizedError.type);

      if (!errorType) {
        return;
      }

      const currentEntity = error.data?.entity;
      const isLive = ['BROADCAST', 'EVENT'].includes(currentEntity.type ?? '');

      const metadata = {
        isLive,
        channel: isLive ? currentEntity.presentationTitle! : '',
      };
      const vodEntity = onEither(currentEntity, ['Episode', 'Movie', 'Program']);
      const npaw = {
        viewerId: this.user.npawId,
        presentationTitle: currentEntity.presentationTitle ?? currentEntity.title,
        guid: currentEntity.guid,
        genre:
          vodEntity?.genres?.nodes?.join(', ') ??
          vodEntity?.categories?.nodes?.join(', ') ??
          undefined,
        type: currentEntity.type ?? undefined,
      } as Media['tracking']['npaw'];

      this.player.npawPluginManager.setVideoOptions({ metadata, tracking: { npaw } });
      this.player.npawPluginManager.fireBusinessError(errorType);
    }
  }
}
